import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeResourceUrl } from '@angular/platform-browser';
import { PlatformService } from '@modules/core/services/platform.service';
import { ContentType } from '@modules/shared/enums/content-type';
import { FilePreviewer } from '@modules/shared/models/file-previewer';
import {  timer } from 'rxjs';

@Component({
  selector: 'app-file-previewer-dialog',
  templateUrl: './file-previewer-dialog.component.html',
  styleUrls: ['./file-previewer-dialog.component.scss']
})
export class FilePreviewerDialogComponent implements OnInit {
  showProgressIdicator = true;
  contentTypes = ContentType;
  contentSource: string | SafeResourceUrl | File;
  contentType: string;
  isMultimediaType: boolean = true;
  isPlatformBrowser: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: FilePreviewer, private platformService: PlatformService) { }

  ngOnInit(): void {
    this.contentType = this.data.contentType;
    this.contentSource = this.data.contentSource;
    this.isPlatformBrowser = this.platformService.isBrowser;
    this.isMultimediaType = this.data.isMultimediaType;
  }

  toggleLoading(): void {
    timer(2000).subscribe(() => {
      this.showProgressIdicator = false;
    });
  }

}
